import { string } from 'yup';

export const omitHtml = (value?: string) => value?.replace(/<(.|\n)*?>/g, '').trim().length !== 0;

export const validateWithoutHtml = (message: string) => string().test('omit-html', message, (value) => omitHtml(value));
